import { render } from "./titleColor.vue?vue&type=template&id=57152916"
import script from "./titleColor.vue?vue&type=script&lang=js"
export * from "./titleColor.vue?vue&type=script&lang=js"

import "./titleColor.vue?vue&type=style&index=0&id=57152916&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__